module.exports = __webpack_public_path__ + "media/images/close_black-f5721942d279445f0f779e265b4de532.svg";